export default {
  de: {
    title: 'Formate',
    create: 'Format hinzufügen',
    active: 'aktiv',
    inactive: 'inaktiv',
    newName: 'Neues Format',
  },
};
